import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserAndFileAuditComponent } from './user-and-file-audit.component';
import { UserAndFileAuditRoutingModule } from './user-and-file-audit-routing.module';
import { DevExtremeModule } from 'devextreme-angular';
import { FormsModule } from '@angular/forms';
import { UtilityModule } from '../utility/utility.module';

@NgModule({
  declarations: [UserAndFileAuditComponent],
  imports: [
    CommonModule,
    UserAndFileAuditRoutingModule,
    DevExtremeModule,
    FormsModule,
    UtilityModule
  ]
})
export class UserAndFileAuditModule { }
